export const REDIRECT_TO_LOGIN = "/login";
export const REDIRECT_TO_HOME = "/";
export const REDIRECT_TO_ADMIN = "/admin";
export const REDIRECT_TO_COUPONS = "/admin/coupons";
export const REDIRECT_TO_PHOTO_SIZES = "/admin/photo-size";
export const REDIRECT_TO_USER = "/admin/user";
export const REDIRECT_TO_ORDER = "/admin/order";
export const REDIRECT_TO_DELIVERY = "/order/delivery";
export const REDIRECT_TO_PHOTO_OPTIONS = "/order/photo-options";
export const REDIRECT_TO_ADDITIONAL_SERVICES = "/order/additional-services";
export const REDIRECT_TO_SUMMARY = "/order/summary";
export const REDIRECT_TO_PAYMENT_ON_DELIVERY = "/order/payment-on-delivery";
export const REDIRECT_TO_PAYMENT = "/order/payment";
export const REDIRECT_TO_CONFIRMATION = "/order/confirmation";
export const REDIRECT_TO_ORDER_HISTORY = "/order/history";
export const REDIRECT_TO_MY_EVENTS = "/dogodki";
